<template lang="html">
  <div class="">
    <Comments
      :comments-show="commentsShow"
      comment-applabel="program"
      comment-classname="episode"
      :comment-objectid="this.episodeId"
      v-on:close-comments="closeComments"
      v-on:comment-created="commentCreated"
    />
    <BuyGiftCard
      :show="buyGiftCardShow"
      @sku-closed="skuClosed"
      :object-id="episodeId"
      @pay-gift-card="payGiftCard"
    />

    <van-action-sheet
      v-model="previewShow"
      :actions="actions"
      title="试听"
    >
      <AudioPlayer
        :episodeId="episodeId"
      />
    </van-action-sheet>

    <van-action-sheet
      v-model="listenPanelShow"
      :actions="actions"
      title="收听"
    >
      <ListenPanel
        :xcx-code="xcxCode"
      />
    </van-action-sheet>

    <van-goods-action safe-area-inset-bottom class="van-hairline--top">
      <van-goods-action-icon
        icon="home-o"
        text="首页"
        @click="home"
      />
      <van-goods-action-icon
        v-if="premium"
        icon="gift-o"
        text="赠送"
        @click="buyGiftCard"
      />
      <!-- <van-goods-action-icon
        icon="comment-o"
        text="评论"
        :info="finalCommentsCount"
        @click="comments"
      /> -->
      <!-- <van-goods-action-icon
        icon="like-o"
        text="收藏"
        @click="favorite"
      /> -->
      <template v-if="checkingPurchaseStatus">
        <span style="text-align:center;display:inline-block;width:100%;">
          <van-loading size="24px">加载中...</van-loading>
        </span>
      </template>
      <template v-else>
        <template v-if="paySuccess || !premium">
          <van-goods-action-icon
            icon="comment-o"
            text="评论"
            :badge="finalCommentsCount"
            @click="comments"
          />
          <van-goods-action-button type="primary" text="收听" @click="listen" />
          <!-- <van-button style="width:100%;" round type="primary" @click="listen">收听</van-button> -->
        </template>
        <template v-else>
          <van-goods-action-button type="info" text="试听" @click="preview" />
          <van-goods-action-button type="primary" text="购买" @click="buy" />
        </template>
      </template>
    </van-goods-action>
  </div>
</template>

<script>
  import AudioPlayer from './audio-player.vue'
  import ListenPanel from './listen-panel.vue'
  import Comments from './comments.vue'
  import BuyGiftCard from './buy-giftcard.vue'
  import Vue from 'vue'
  import {
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton
  } from 'vant'
  import { ActionSheet } from 'vant'
  import { Notify } from 'vant'
  import { Loading } from 'vant'
  import router from '../router'
  import store from '../store/index';
  Vue
    .use(GoodsAction)
    .use(GoodsActionIcon)
    .use(GoodsActionButton)
  Vue.use(ActionSheet)
  Vue.use(Notify)
  Vue.use(Loading)

  export default {
    name: 'action-bar',
    components: {
      AudioPlayer,
      ListenPanel,
      Comments,
      BuyGiftCard
    },
    data () {
      return {
        previewShow: false,
        commentsShow: false,
        buyGiftCardShow: false,
        checkingPurchaseStatus: true,
        paySuccess: false, // 支付成功（已购买）
        listenPanelShow: false,
        actions: [],
        isDemoUser: false // 临时加入字段，判断是否可见demo功能
      }
    },
    props: {
      showSlug: String,
      episodeId: Number,
      xcxCode: Number,
      premium: {
        type: Boolean,
        default: false
      },
      commentsCount: Number
    },
    watch: {
      episodeId: function (newVal, oldVal) {
        if (newVal != oldVal) {
          let that = this
          let params = {
            applabel: 'program',
            classname: 'episode',
            objectid: that.episodeId
          }
          window.console.log("参数：")
          window.console.log(params)
          that.$api.productitem.purchase_status(params).then(res => {
            window.console.log("购买状态")
            // window.console.log(res.data.purchased)
            window.console.log(res.data)
            let purchased = res.data.purchased.purchased
            let redeem_status = res.data.redeem_status
            if (purchased || redeem_status == 'redeemed') {
              that.paySuccess = true
            }
            that.checkingPurchaseStatus = false
            // 临时判断demo user身份
            if (res.data.purchased.demo_user) {
              that.isDemoUser = true
            }
          })
        }
      }
    },
    computed: {
      finalCommentsCount () {
        if (this.commentsCount > 0) {
          return this.commentsCount
        } else {
          return ''
        }
      }
    },
    methods: {
      commentCreated () {
        this.$emit('comment-created')
        this.closeComments()
      },
      closeComments () {
        this.commentsShow = false
      },
      home () {
        window.console.log("去首页")
        this.$router.replace({
          // name: 'ShowDetail',
          name: 'Discovery',
          params: {
            slug: this.showSlug
          }
        })
      },
      buyGiftCard () {
        // window.console.log("赠送")
        this.buyGiftCardShow = true
        // window.console.log(this.showBuyGiftCard)
      },
      payGiftCard (data) {
        let giftCardId = data.giftCardId
        // 保存当前url作为支付后跳转页
        // store.commit('setProductUrl', router.currentRoute.fullPath)
        // 保存giftcard详情页作为支付成功后跳转页
        let giftCardDetailPage = `/giftcard/${giftCardId}`
        let payFailUrl = router.currentRoute.fullPath
        store.commit('setProductUrl', giftCardDetailPage)
        store.commit('setPayFailUrl', payFailUrl)
        // 跳转支付页面
        this.$router.replace({
          name: `PayWechat`,
          query: {
            applabel: 'social',
            classname: 'giftcard',
            objectid: giftCardId
          }
        })
      },
      skuClosed () {
        this.buyGiftCardShow = false
      },
      cancel () {
        this.show = false
      },
      preview () {
        this.previewShow = true
      },
      listen () {
        this.listenPanelShow = true
      },
      comments () {
        this.commentsShow = true
      },
      buy () {
        // 保存当前url作为支付后跳转页
        store.commit('setProductUrl', router.currentRoute.fullPath)
        // 跳转支付页面
        this.$router.replace({
          name: `PayWechat`,
          query: {
            applabel: 'program',
            classname: 'episode',
            objectid: this.episodeId
          }
        })
      },
    },
    mounted () {
      if (store.state.paymentResult.message) {
        let type
        if (store.state.paymentResult.success) {
          type = 'success'
          this.paySuccess = true
        } else {
          type = 'warning'
        }
        Notify({ type: type, message: store.state.paymentResult.message })
        store.commit('clearPaymentResult')

        // 清理返回信息，否则左上角会出现返回到支付流程的按钮
        store.commit("clearPrevFullPath")
      }
    }
  }
</script>

<style lang="css" scoped>
</style>
